import DetailsCard from "../DetailsCard";
import { format } from "date-fns";

const DashboardOrdersSent = ({ ordersSentData, loading, filters, setFilters }) => {
    if (!ordersSentData) return null;

    const { statistics, last_sent_orders } = ordersSentData;

    return (
        <div className="mt-5">
            <h3 className="text-center mb-5">
                Estadísticas de Tiempos de Envío
            </h3>
            <div className="row justify-content-end">
                <div className="col-md-4 mb-3">
                    <select
                        className="form-control"
                        value={filters?.orderTypeId}
                        onChange={(e) => setFilters(old => ({ ...old, orderTypeId: e.target.value }))}
                    >
                        <option value="">Tipo de pedido</option>
                        <option value="1">Mensual</option>
                        <option value="2">Extraordinario</option>
                        <option value="3">Manual</option>
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-4 col-sm-6">
                    <DetailsCard
                        title={'Pedido más rapido'}
                        loading={loading}
                        icon='fa fa-arrow-down'
                        value={statistics?.min_sent_days ? `${statistics?.min_sent_days} días` : '--'}
                        gradient="gradient-4"
                    />
                </div>
                <div className="col-xl-4 col-sm-6">
                    <DetailsCard
                        title={'Tiempo promedio de envio'}
                        loading={loading}
                        icon='fa fa-clock'
                        value={statistics?.avg_sent_days ? `${statistics?.avg_sent_days} días` : '--'}
                        gradient="gradient-3"
                    />
                </div>
                <div className="col-xl-4 col-sm-6">
                    <DetailsCard
                        title={'Envió que mas tardó'}
                        loading={loading}
                        icon='fa fa-arrow-up'
                        value={statistics?.max_sent_days ? `${statistics?.max_sent_days} días` : '--'}
                        gradient="gradient-2"
                    />
                </div>
            </div>

            <h4 className="text-center mt-5 mb-4">
                Detalle de los pedidos
            </h4>

            <div className="table-responsive">
                <table className="table table-striped table-bordered text-center">
                    <thead className="bg-light">
                        <tr>
                            <th>Servicio</th>
                            <th># Pedido</th>
                            <th>Tipo de pedido</th>
                            <th>Fecha de Creación</th>
                            <th>Fecha de Aprobación</th>
                            <th>Fecha de Envio</th>
                            <th>Días en Enviar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7" className="text-center">Cargando...</td>
                            </tr>
                        ) : (
                            last_sent_orders && last_sent_orders.length > 0 ? (
                                last_sent_orders.map((order, i) => (
                                    <tr key={i}>
                                        <td>{order.service_name}</td>
                                        <td>{order.id}</td>
                                        <td>{order.order_type_name}</td>
                                        <td>{order.created_at ? format(new Date(order.created_at), 'dd/MM/yyyy HH:mm') : '--'}</td>
                                        <td>{order.approved_at ? format(new Date(order.approved_at), 'dd/MM/yyyy HH:mm') : '--'}</td>
                                        <td>{order.sent_at ? format(new Date(order.sent_at), 'dd/MM/yyyy HH:mm') : '--'}</td>
                                        <td>{order.sent_days ?? '--'} {order.sent_days ? Number(order.sent_days) === 1 ? 'día' : 'días' : ''}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center text-danger">No hay pedidos para mostrar.</td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DashboardOrdersSent;
